<template>
  <div
    class="base-shimmer"
    :class="{ animate, circular }"
    data-pendo-gc="shimmer"
    :style="{
      width: width,
      height: height,
      '--color-primary': `var(--${color}-${colorShadePrimary})`,
      '--color-secondary': `var(--${color}-${colorShadeSecondary})`,
    }"
  />
</template>

<script>

const COLOR_OPTIONS = [
  'pepper',
  'baja-blast',
  'bananarama',
  'blueberry',
  'candy-wrapper',
  'chicago-dog-red',
  'clementine',
  'grape-jelly',
  'icee-blue',
  'spearmint',
  'spinach',
]

export default {
  name: 'BaseShimmer',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    animate: {
      type: Boolean,
      default: true,
    },
    circular: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'pepper',
      validator: function (value) {
        return COLOR_OPTIONS.includes(value)
      },
    },
  },
  computed: {
    colorShadePrimary() {
      return this.color === 'pepper' ? '50' : '100'
    },
    colorShadeSecondary() {
      return this.color === 'pepper' ? '100' : '200'
    },
  },
}
</script>

<style scoped>
.base-shimmer {
  position: relative;
  border-radius: var(--cr-br-small);

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(
      90deg,
      var(--color-primary) 0%,
      var(--color-secondary) 50%,
      var(--color-primary) 100%
    );
    background-size: 200% 200%;
    border-radius: var(--cr-br-small);
  }

  &:not(.animate)::after {
    background: var(--pepper-50);
  }

  &.animate::after {
    animation: loading 1.8s ease-in-out infinite;
  }

  &.circular,
  &.circular::after {
    border-radius: 50%;
  }
}

@keyframes loading {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}
</style>
